/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../configs/config";
const epIngresoArticulo = "v1/ingreso-articulo/";
const epNameArticuloByCodigo = "v1/articulo/"

const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getIngresosArticulo = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Ingresos de Artículos";

  if (params) {
    if (params.codigo) {
      _params.codigo = params.codigo;
    }

    if (params.idArea) {
      _params.id_area = params.idArea;
    }

    if (params.idProveedor) {
      _params.id_proveedor = params.idProveedor;
    }

    if (params.usuario) {
      _params.id_usuario = params.usuario;
    }

    if (params.fechaCreacionDesde) {
      _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
    }

    if (params.fechaCreacionHasta) {
      _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
    }

    if (params.estadoActual) {
      _params.estado_actual = params.estadoActual;
    }

    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epIngresoArticulo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.message_code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getIngresoArticulo = async (parIdIngreso) => {
  let _errorMessage = "Se produjo un error al obtener el Ingreso de artículo";
  let _params = {};
  _params.id = parIdIngreso;
  _params.id_area = localStorage.getItem("id_area_deposito");


  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epIngresoArticulo}`,
      params: _params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
      if (response.data.code === "err-ingreso-articulo-area-not-allowed") {
        response.ok = false;
        response.messageText = "El Área solicitante no es el Área del Ingreso.";
        response.messageSeverity = "error";
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveIngresoArticulo = async (parAction, parIngresoArticulo) => {

  let _errorMessage = "";

  if (parAction === "new" || parAction === "update") {
    _errorMessage = "No fue posible guardar el Ingreso de Artículos";
  } else {
    _errorMessage = "No fue posible anular el Ingreso de Artículos";
  }
  parIngresoArticulo.id_area = localStorage.getItem("id_area_deposito");
  parIngresoArticulo.id_usuario = localStorage.getItem("id_usuario");

  try {

    let response = {};

    if (parAction === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epIngresoArticulo}`,
        data: parIngresoArticulo,
      });
    } else if (parAction === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epIngresoArticulo}`,
        data: parIngresoArticulo,
      });
    } else {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epIngresoArticulo}`,
        params: parIngresoArticulo,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `Ingreso de Artículos ${["new", "update"].includes(parAction) ? "guardado" : "anulado"}`;
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-ingreso-articulo-existencia-disponible-insuficiente") {
        response.ok = false;
        response.messageText = "La cantidad del artículo en el Área es insuficiente.";
        response.messageSeverity = "error";
        return response;
      } else if
        (response.data.code === "err-ingreso-articulo-not-enabled") {
        response.ok = false;
        response.messageText = "El artículo que intentas ingresar no está habilitado.";
        response.messageSeverity = "error";
        return response;
      } else if
        (response.data.code === "err-ingreso-articulo-area-ingreso-articulo-not-allowed") {
        response.ok = false;
        response.messageText = "El Área en la que te encuentras no está parametrizada para registrar ingresos de artículos.";
        response.messageSeverity = "error";
        return response;
      }
    }

    // si hay error controlado lsalvador

    console.log(_errorMessage);
    console.log(response);

    response.messageText = _errorMessage;
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};